import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ConnectionStatus, ConnectivityService } from '../services/connectivity.service';

@Component({
  selector: 'app-connection-warning',
  templateUrl: './connection-warning.component.html',
  styleUrls: ['./connection-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionWarningComponent implements OnInit, OnDestroy {
  private readonly connectivityService = inject(ConnectivityService);
  readonly status$ = this.connectivityService.status$;

  ngOnInit(): void {
    this.connectivityService.start();
  }

  ngOnDestroy(): void {
    this.connectivityService.stop();
  }

  messageKey(status: ConnectionStatus): string {
    return status === 'offline' ? 'CONNECTION.OFFLINE' : 'CONNECTION.SERVICE_UNREACHABLE';
  }
}
